<template>
  <div class="mx-5 mt-5"><SelezioneMultipla /></div>
</template>
<script>
import SelezioneMultipla from "@/views/PRODUCTION/SelezioneMultipla/SelezioneMultipla.vue";
export default {
  name: "SelezioneMultiplaEMAdapter",
  components: {
    SelezioneMultipla,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>